import React, {useEffect} from 'react'
import Modal from 'react-bootstrap/Modal'
import ClassEditor from 'components/Store/ClassEditor'
import DropdownButton from 'react-bootstrap/DropdownButton'
import Dropdown from 'react-bootstrap/Dropdown'
import {useDispatch, useSelector} from 'react-redux'
import { useForm, Controller } from "react-hook-form";
import { DevTool } from "react-hook-form-devtools";
import * as yup from 'yup';
import FormGroup from 'components/Form/FormGroup'
import Button from 'react-bootstrap/Button'
import { saveProduct } from 'store/actions/productActions'
import SweetAlert from 'react-bootstrap-sweetalert'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit';
import { deleteProduct } from 'store/actions/productActions'
import analytics from 'util/analytics';
import Spinner from 'react-bootstrap/Spinner'
import FormImageUploader from 'components/Form/FormImageUploader'
import FormFile from 'components/Form/FormFile'
import FormDatePicker from 'components/Form/FormDatePicker'
import * as moment from 'moment-timezone'
import {symbolFromCurrency} from 'components/PartnerInfoForm'
import { workoutOptions, bodyOptions, intensityOptions, equipmentOptions } from 'components/Store/ClassEditor'
// import { Accordion } from '@material-ui/core'
// import Accordion from 'react-bootstrap/Accordion';
import Collapse from 'react-bootstrap/Collapse'
const DATE_FORMAT = 'ddd MMM D, YYYY';

const productTypeOptions = [
    {label: "Private Link", value: "link"},
    {label: "Computer File", value: "file"}
]

const videoTypeOptions = [
    {label: "Vimeo Link", value: "video/vimeo"},
    // {label: "Youtube Link", value: "video/youtube"},
    {label: "Video File (.mp4 or .mov)", value: "file"}
]


// const defaultValues = {
//     id: toEdit?.id,
//     name: toEdit?.name || "",
//     price: toEdit?.price,
//     description: toEdit?.description || "",
//     descriptionHTML: toEdit?.descriptionHTML ?? "",
//     imageUrl: toEdit?.images[0] ?? null,
//     onDemand: toEdit?.onDemand ?? {
//         fileName: "",
//         fileType: "",
//         downloadLink: ""
//     },
//     categories: toEdit?.categories ?? [],
//     hidden: toEdit?.hidden ?? false,
//     expirationDate: toEdit?.expirationDate,
//     classId: toEdit?.classId, // If this relates to some class
//     location_type: "product",
// }
const productTemplate = {
    id: "1234545",
    name: "Beach workshop",
    price: 10,
    description: "come join me on the beach for an awesome workout",
    images: ["https://firebasestorage.googleapis.com/v0/b/sutra-prod.appspot.com/o/users%2Fl2hWkuaSo4csUnVffJjO%2Fservices%2F1593569050210-Clippy.jpg?alt=media&token=0142b049-616d-436d-9afa-94b9de30b2a5"],
    onDemand: {
        fileName: "",
        fileType: "",
        downloadLink: ""
    },
    // categories: toEdit?.categories ?? [],
    // hidden: toEdit?.hidden ?? false,
    // expirationDate: toEdit?.expirationDate,
    // classId: toEdit?.classId, // If this relates to some class
    location_type: "product", // ondemand
    purchase_type: "Paid",

    partnerId: "21345",
    instructor_id: "l2hWkuaSo4csUnVffJjO",
    host_ids: [
        "l2hWkuaSo4csUnVffJjO"
    ],
    host_name: "Joshua",
    
    created: 1594261865,
    deleted: false,
    canceled: false,
    content_link: "https://www.google.com/maps/place/33.6074678,-117.9288111",
    
    
    ///// ** OTHER ***
    "duration": 60,
    "end_time": 1604291340,
    "equipment_required": ["Weights"],
    "experience_type": "Workshop",
    "host_ids": [
        "l2hWkuaSo4csUnVffJjO"
    ],
    "host_name": "Joshua",
    "instructor_id": "l2hWkuaSo4csUnVffJjO",
    "instructor_name": "Joshua",
    "intensity": "",
    "location": {
        "address": "Newport Beach Pier, Newport Pier, Newport Beach, CA, USA",
        "cityState": "Balboa Peninsula, CA",
        "contentLink": "https://www.google.com/maps/place/33.6074678,-117.9288111",
        "lat": 33.6074678,
        "lng": -117.9288111
    },
    "location_name": "In person",
    "minimum_price": 0,
    "preview_url": "",
    "reserve_link": "Newport Beach Pier, Newport Pier, Newport Beach, CA, USA",
    "service_id": "yAqKi2lVyJbY1yn8XVKQ",
    "start_time": 1604287740,
    
    "workout_types": ["Bootcamp"]
}

function ProductEditor(props) {
    const dispatch = useDispatch()

    var { toEdit, productType } = props
    const {challengeid} = props

    // console.log("product to edit: ", toEdit)

    const partnerId = useSelector(state => state.instructor.instructor.platformID)
    const classes = useSelector(state => state.instructor.classes)
    const currency = useSelector(state => state.instructor.instructor?.instructorProfile?.currency ?? "USD")
    
    const possibleClasses = classes.filter(val => {
        return val.start_time < moment().unix() && val.start_time > moment().add(-1, 'M').unix()
    }).sort((a,b) => {
        return (b?.start_time ?? 0) - (a?.start_time ?? 0)
    })

    const classMap = classes.reduce((map, obj) => {
        if (obj.platformID) {
            map[obj.platformID] = obj
        }
        return map
    }, {})
    
    const classOptions = possibleClasses.map(val => {
        return {
            label: (val.name ?? val.class_name) + " on " + moment(val.start_time * 1000).format("LL"),
            value: val.platformID
        }
    }).concat({
        label: "None",
        value: ""
    })

    // MARK: - Categories
    // Attempting to support pulling in all existing categories
    const productCategories = useSelector(state => state.instructor.products.reduce((allCategories, val) => {
        if (!val?.categories || val.categories.length < 1) {
            return allCategories
        } else {
            return val.categories.map(val => {return {label: val, value: val}}).concat(allCategories)
        }
    }, []));
    // const [possibleCategories, setPossibleCategories] = React.useState(toEdit?.categories?.map(val => {return {label: val, value: val}}) ?? [])
    const [newCategories, setNewCategories] = React.useState([])
    const ughCategories = productCategories.concat(newCategories)
    let possibleCategories = [];
    const map = new Map();
    for (const item of ughCategories) {
        if(!map.has(item.value)){
            map.set(item.value, true);    // set any value to Map
            possibleCategories.push({
                value: item.value,
                label: item.label
            });
        }
    }

    // MARK: - Filter
    const productFilters = useSelector(state => state.instructor.products.reduce((allFilters, val) => {
        if (!val?.filters || val.filters.length < 1) {
            return allFilters
        } else {
            return val.filters.map(val => {return {label: val, value: val}}).concat(allFilters)
        }
    }, []));
    // const [possibleCategories, setPossibleCategories] = React.useState(toEdit?.categories?.map(val => {return {label: val, value: val}}) ?? [])
    const [newFilters, setNewFilters] = React.useState([])
    const ughFilters = productFilters.concat(newFilters)
    let possibleFilters = [];
    const filterMap = new Map();
    for (const item of ughFilters) {
        if(!filterMap.has(item.value)){
            filterMap.set(item.value, true);    // set any value to Map
            possibleFilters.push({
                value: item.value,
                label: item.label
            });
        }
    }


    // END: - Filters
 
    // const defualtToEdit = {...toEdit}
    const { register, control, handleSubmit, setValue, errors, getValues, watch } = useForm({
        mode: 'onBlur',
        validationSchema: yup.object({
            name: yup.string().required('Please enter a name'),
            description: yup.string(),
            duration: yup.number().positive(),
            // price: challengeid ? yup.number() : yup.number("Please enter a valid price greater than zero").required('Please enter a price').typeError('Please enter a valid price greater than zero'),
            imageUrl: yup.string().required("Please upload a preview image").typeError('Please upload a preview image'),
            formProductType: yup.string().required("Please pick one"),
            websiteUrl: yup.string()
            .url()
            .when('formProductType', {
                is: 'link',
                then: yup.string().matches(
                    /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/,
                    'Enter correct website address!'
                )
                .required('Please enter website')
            }),
            onDemand: yup.object().when('productType', {
                is: 'file',
                then: yup.object()
                .shape({
                    storagePath: yup.string().required("Something went wrong uploading the file, please try again"),
                    fileName: yup.string().required("Something went wrong uploading the file, please try again"),
                    fileType: yup.string().required("Something went wrong uploading the file, please try again"),
                    downloadUrl: yup.string().required("Something went wrong uploading the file, please try again").test('last_name', 'Last Name test message', function(value) {
                        if (!!value) {
                          return false; // this works as expected
                        }
                        return true; // <-- How do I do a sync test here like yup.string(value).min(2)
                    }),
                }).required('please choose a file')
            }),
            allowsDropin: yup.bool(),
            price: yup.number().when('allowsDropin', {
                is: true,
                then: challengeid ? yup.number() : yup.number("Please enter a valid price greater than zero").required('Please enter a price').typeError('Please enter a valid price greater than zero')
            }),

            allowsRental: yup.bool(),
            rentalPeriodHours: yup.number().when('allowsRental', {
                is: true,
                then: yup.number("Please enter a valid number grater than zero").positive('Please enter a valid number grater than zero').required("Please enter a valid number grater than zero")
            }),
            rentalPrice: yup.number().when('allowsRental', {
                is: true,
                then: yup.number("Please enter a valid number grater than zero").required("Please enter a valid number grater than zero").typeError('Please enter a valid price greater than zero')
            })
        }),
        defaultValues: {
            id: toEdit?.id,
            name: toEdit?.name || "",
            description: toEdit?.description || "",
            descriptionHTML: toEdit?.descriptionHTML ?? "",
            imageUrl: toEdit?.images ? toEdit.images[0] : null,
            formProductType: toEdit?.formProductType ?? "file",
            websiteUrl: toEdit?.websiteUrl ?? "",
            onDemand: toEdit?.onDemand ?? {
                storagePath: "",
                fileName: "",
                fileType: "",
                downloadUrl: "",
            },
            categories: toEdit?.categories ?? [],
            filters: toEdit?.filters ?? [],
            hidden: toEdit?.hidden ?? false,
            expirationDate: toEdit?.expirationDate ? moment(toEdit.expirationDate * 1000).format(DATE_FORMAT) : moment().add(5,'years').format(DATE_FORMAT),
            created: toEdit?.created ? moment(toEdit.created * 1000).format(DATE_FORMAT) : moment().format(DATE_FORMAT),
            classId: toEdit?.classId, // If this relates to some class
            location_type: "",
            dropinOnly: toEdit?.dropinOnly ?? false,
            allowsDropin: ('undefined' !== typeof (toEdit?.allowsDropin)) ? toEdit.allowsDropin : false,
            price: toEdit?.price ?? 10,

            allowsRental: ('undefined' !== typeof (toEdit?.allowsRental)) ? toEdit.allowsRental : true,
            rentalPrice: toEdit?.rentalPrice ?? 10,
            rentalPeriodHours: toEdit?.rentalPeriodHours ?? 24,

            workout_types: toEdit?.workout_types ?? [],
            body_focus: toEdit?.body_focus ?? "",
            equipment_required: toEdit?.equipment_required ?? [],
            duration: toEdit?.duration ?? 60
        }
    });
    const {formProductType, allowsDropin, allowsRental, dropinOnly} = watch()

    console.log('selected: ', toEdit)
    useEffect(() => {
        // register({ name: 'id'})
        if (productType === 'ondemand') {
            register({name: 'formProductType'})
        }
        register({ name: 'onDemand'})
        register({ name: 'imageUrl'})
        // register({ name: 'price'})
        // register({ name: 'onDemand.fileName'})
        // register({ name: 'onDemand.fileType'})
        // register({ name: 'onDemand.downloadLink'})
        // register({ name: 'active'})
    }, [register])

    const [isSaving, setIsSaving] = React.useState(false)
    const [saveError, setSaveError] = React.useState(null)

    const productTemplate = {
        id: "1234545",
        name: "Beach workshop",
        price: 10,
        description: "come join me on the beach for an awesome workout",
        images: ["https://firebasestorage.googleapis.com/v0/b/sutra-prod.appspot.com/o/users%2Fl2hWkuaSo4csUnVffJjO%2Fservices%2F1593569050210-Clippy.jpg?alt=media&token=0142b049-616d-436d-9afa-94b9de30b2a5"],
        onDemand: toEdit?.onDemand ?? {
            fileName: "",
            fileType: "",
            downloadUrl: ""
        },
        categories: toEdit?.categories ?? [],
        hidden: toEdit?.hidden ?? false,
        expirationDate: toEdit?.expirationDate ? moment(toEdit.expirationDate * 1000).format(DATE_FORMAT) : moment().format(DATE_FORMAT),
        classId: toEdit?.classId, // If this relates to some class
        location_type: productType,
        purchase_type: "Paid",
    
        // partnerId: "21345",
        // instructor_id: "l2hWkuaSo4csUnVffJjO",
        // host_ids: [
        //     "l2hWkuaSo4csUnVffJjO"
        // ],
        // host_name: "Joshua",
        
        created: 1594261865,
        deleted: false,
        canceled: false,
        content_link: "https://www.google.com/maps/place/33.6074678,-117.9288111",
    } 

    if (errors) {
        console.log("Errors with teh form: ", errors)
    }

    const onSubmit = (data) => {

        if (data.dropinOnly && !allowsDropin && !allowsRental) {
            window.alert("Must provide pricing option")
            return
        }

        if (productType === "product" || productType === "ondemand") {
            data.location_type = productType

            if (['link', 'video/vimeo', 'video/youtube'].includes(data.formProductType)) {
                data.onDemand = {
                    storagePath: data.formProductType,
                    fileName: data.formProductType,
                    fileType: data.formProductType,
                    downloadUrl: data.websiteUrl
                }
            }

        } else if (toEdit?.location_type) {
            data.location_type = toEdit.location_type
        } else {
            window.alert("Error saving")
            return 
        }
        if (!data?.onDemand?.downloadUrl) {
            window.alert("Please wait for the file to finish uploading before saving.")
            return
        }

        data.purchase_type = "Paid"
        if (data.imageUrl) {
            data.images = [data.imageUrl]
        }
        delete data.imageUrl
        if (data.expirationDate) {
            data.expirationDate = moment(data.expirationDate, DATE_FORMAT).endOf('day').unix()
        } else {
            data.expirationDate = moment().add(50,'years').unix()
        }

        if (data.created) {
            data.created = moment(data.created, DATE_FORMAT).endOf('day').unix()
        } else {
            data.expirationDate = moment().unix()
        }

        if (data.classId && classMap[data.classId]) {
            const theClass = classMap[data.classId]
            data.classSnapshot = {...theClass}
            data.created = theClass.start_time ?? moment().unix()
        }
        
        if (toEdit) {
            data.updated = moment.unix()
        }

        if (challengeid) {
            data.challengeId = challengeid
        }

        // if (data.isSubscriptionOnly) {
        //     data.isRental = false
        //     data.rentalPeriodHours = 9999999
        // }
        
        // var expiresIn = 99999 // set expiresIn based on frequency
        // if (data.frequency) {
        //     expiresIn = expiresInFromFrequency(data.frequency)
        // }

        const newData = {
            ...toEdit,
            ...data
        }

        // console.log(`going to save this: `, newData)
        // return 
        setIsSaving(true)
        dispatch(saveProduct(newData))
            .then(result => {
                if (result.success === false && result.message) {
                    throw result.message
                }
                setIsSaving(false)
                if (props.onHide) {
                    props.onHide()
                }
            })
            .catch(err => {
                setIsSaving(false)
                setSaveError(err)
                // console.log("WTF got an error: ", err)
                window.alert(err)
            })
        
    }

    var viewModel = {
        placeholders: {
            name: "Product name",
            price: "10",
            description: "Optional. Tell your clients what this is all about"
        }
    }

    const handleSelectedClass = (id) => {
        const theClass = classMap[id]
        if (theClass) {
            console.log("Found a class: ", theClass)
            setValue('name', "(Recorded) " + (theClass.name ?? theClass.class_name))
            setValue('description', theClass.description ?? theClass.class_about)
            setValue('created',  moment(theClass.start_time * 1000).format(DATE_FORMAT))

            if (theClass.workout_types) {
                setValue('workout_types', theClass.workout_types)
            }
            if (theClass.body_focus) {
                setValue('body_focus', theClass.body_focus)
            }
            if (theClass.equipment_required) {
                setValue('equipment_required', theClass.equipment_required)
            }

            if (theClass.duration) {
                setValue('duration', theClass.duration)
            }
        }
    }

    const [filtersOpen, setFiltersOpen] = React.useState(false)
    const [configOpen, setConfigOpen] = React.useState(false)
    return (
        <>
        <form onSubmit={handleSubmit(onSubmit)}>

            {!challengeid && (<>
                <FormGroup 
                fullSize
                select
                options={classOptions}
                type="multiselect"
                name="classId"
                label="Class"
                sublabel="Does this pertain to a class? If so class attendees will be able to access this recording until the expiration date."
                placeholder="Optional"
                control={control}
                setValue={setValue}
                getValues={getValues}
                newSelection={(selected) => {
                    handleSelectedClass(selected)
                    // console.log(selected)
                }}
                />
            </>
            )}

            <hr></hr>

            <h4 className="font-weight-bold mb-4">Details</h4>

            <FormGroup
                type="text"
                name="name"
                label="Name"
                placeholder={viewModel.placeholders.name}
                register={register}
                error={errors.name}
                fullSize
            />

            <FormImageUploader
                fullSize
                imageUrl={toEdit?.imageUrl}
                name="imageUrl"
                label="Preview Image"
                // defaultName={user.instructorProfile?.pageName}
                filePath={`users/${partnerId}/files/`}
                sublabel={"Anyone can see this image, recommended size 637×333"}
                register={register}
                onChange={(imageUrl) => setValue('imageUrl', imageUrl)}
                imageUrl={getValues("imageUrl")}
                error={errors.imageUrl}
                // getValues={getValues}
                // fileSelection={(file) => setValue('imageUrl', file)}
            />

            {productType === "product" && (
                <FormGroup 
                    select
                    options={productTypeOptions}
                    type="text"
                    name="formProductType"
                    label="Type of file"
                    sublabel="Uploading a file or a private link"
                    placeholder="Select one"
                    error={errors.formProductType}
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                    fullSize
                />
            )}

            {productType === "ondemand" && (
                <FormGroup 
                    select
                    options={videoTypeOptions}
                    type="text"
                    name="formProductType"
                    label="Type of video"
                    sublabel="Uploading a file or using a video link"
                    placeholder="Select one"
                    error={errors.formProductType}
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                    fullSize
                />
            )}

            {productType === "product" && formProductType === 'link' && (
                <FormGroup
                    type="url"
                    name="websiteUrl"
                    label="Private Link"
                    sublabel="Spotify playlist, private google doc, etc."
                    placeholder={`https://spotify.com/your-super-secret-playlist`}
                    register={register}
                    error={errors.websiteUrl}
                    fullSize
                />
            )}

            {productType === "ondemand" &&  ['video/vimeo', 'video/youtube'].includes(formProductType) && (
                <FormGroup
                    type="url"
                    name="websiteUrl"
                    label="Private Link"
                    // sublabel="Spotify playlist, private google doc, etc."
                    placeholder={`https://vimeo.com/slkjdflkj`}
                    register={register}
                    error={errors.websiteUrl}
                    fullSize
                />
            )}

            {(formProductType === 'file') && (
                <FormFile
                    style={{display: "none"}}
                    fullSize
                    onDemand={toEdit?.onDemand}
                    // imageUrl={toEdit?.imageUrl}
                    name="onDemand"
                    label="File"
                    filePath={`users/${partnerId}/files/`}
                    // defaultName={user.instructorProfile?.pageName}
                    sublabel={"Only those that purchase can see this"}
                    register={register}
                    onDemandSelection={(file) => setValue('onDemand', file)}
                />
            )}

            <FormGroup
                type="text"
                textarea
                name="description"
                label="Description"
                placeholder={viewModel.placeholders.description}
                register={register}
                error={errors.description}
                fullSize
                control={control}
                setValue={setValue}
                getValues={getValues}
            />

            <hr></hr>

            <div className="d-flex d-row mb-4">
                <h4 className="font-weight-bold mb-0">Categories &amp; Filters</h4>
                <a
                    className="btn btn-link"
                    type="button"
                    onClick={(e) => setFiltersOpen(!filtersOpen)}
                    aria-controls="example-collapse-text"
                    aria-expanded={filtersOpen}
                >
                    {filtersOpen ? "Close" : "Open"}
                </a>

            </div>
            
            <Collapse in={filtersOpen}>
                <div id="example-collapse-text">
                    <FormGroup 
                        fullSize
                        select
                        isMulti={true}
                        // options={[...possibleCategories].concat([...productCategories])}
                        options={possibleCategories}
                        type="multiselect"
                        name="categories"
                        label="Categories"
                        sublabel="Use this to group products together"
                        placeholder="Type a category here"
                        control={control}
                        setValue={setValue}
                        getValues={getValues} 
                        updateOptions={(options) => {
                            setNewCategories([...newCategories].concat(options))
                        }}
                    />

                    <FormGroup 
                        fullSize
                        select
                        isMulti={true}
                        // options={[...possibleCategories].concat([...productCategories])}
                        options={possibleFilters}
                        type="multiselect"
                        name="filters"
                        label="Custom filters"
                        sublabel="Can't find what you're looking for? Add one here"
                        placeholder="Type a new filter here"
                        control={control}
                        setValue={setValue}
                        getValues={getValues} 
                        updateOptions={(options) => {
                            setNewFilters([...newFilters].concat(options))
                        }}
                    />

                    <FormGroup 
                        fullSize
                        select
                        isMulti={true}
                        options={workoutOptions}
                        type="multiselect"
                        name="workout_types"
                        label="Workout Types"
                        control={control}
                        setValue={setValue}
                        getValues={getValues}
                    />

                    <FormGroup 
                        fullSize
                        select
                        options={bodyOptions}
                        type="multiselect"
                        name="body_focus"
                        label="Body Focus"
                        control={control}
                        setValue={setValue}
                        getValues={getValues}
                    />

                    <FormGroup 
                        fullSize
                        select
                        isMulti={true}
                        options={equipmentOptions}
                        type="multiselect"
                        name="equipment_required"
                        label="Equipment"
                        control={control}
                        setValue={setValue}
                        getValues={getValues}
                    />

                    <FormGroup
                        type="number"
                        name="duration"
                        label="Duration"
                        register={register}
                        error={errors.duration}
                        prepending={["minutes"]}
                        fullSize
                    />
                </div>
            </Collapse>
                
            {/* </Accordion> */}

            <hr></hr>

            {/* <h4 className="font-weight-bold mb-4">Configuration</h4> */}
            <div className="d-flex d-row mb-4">
                <h4 className="font-weight-bold mb-0">Pricing &amp; Configuration</h4>
                <a
                    className="btn btn-link"
                    type="button"
                    onClick={(e) => setConfigOpen(!configOpen)}
                    aria-controls="configOpen-collapse"
                    aria-expanded={configOpen}
                >
                    {configOpen ? "Close" : "Open"}
                </a>

            </div>

            <Collapse in={configOpen}>
                <div id="configOpen-collapse">
                    <div className={challengeid ? "d-none" : ""}>

                        <FormGroup
                            fullSize
                            type="checkbox"
                            name="allowsDropin"
                            label="Allow users to buy"
                            placeholder="Viewers can access and stream this forever"
                            register={register}
                        />
                        <FormGroup
                            className={allowsDropin ? "" : "d-none"}
                            type="number"
                            name="price"
                            label="Purchase price"
                            placeholder={viewModel.placeholders.price}
                            register={register}
                            error={errors.price}
                            prepending={[symbolFromCurrency(currency)]}
                            fullSize
                        />
                        <FormGroup
                            fullSize
                            type="checkbox"
                            name="allowsRental"
                            label="Allow users to rent"
                            placeholder="Viewers can access and stream this for a limited period of time"
                            // prepending={["sutrapro.com"]}
                            register={register}
                        />
                    
                        <FormGroup
                            className={allowsRental ? "" : "d-none"}
                            type="number"
                            name="rentalPrice"
                            label="Rental Price"
                            placeholder={viewModel.placeholders.price}
                            register={register}
                            error={errors.rentalPrice}
                            prepending={[symbolFromCurrency(currency)]}
                            fullSize
                        />

                        <FormGroup
                            className={allowsRental ? "" : "d-none"}
                            type="number"
                            name="rentalPeriodHours"
                            label="Rental Period"
                            sublabel="In Hours"
                            placeholder={"Enter number of hours"}
                            register={register}
                            error={errors.rentalPeriodHours}
                            prepending={["hours"]}
                            fullSize
                        />

                        <FormGroup
                            fullSize
                            type="checkbox"
                            name="dropinOnly"
                            label="Drop-in / Rental Only"
                            placeholder="Subscription members will not be able to access this video"
                            register={register}
                        />

                        {!allowsDropin && !allowsRental && !dropinOnly && (
                            <h6 style={{color: "green"}}>Viewers can only access and stream this with a subscription</h6>
                        )}
                    </div>

                    <FormDatePicker
                        fullSize
                        name="created"
                        label="Creation Date"
                        sublabel="The library will be sorted by date from newest to oldest"
                        placeholder="Select date"
                        getValues={getValues}
                        control={control}
                        dateFormat={DATE_FORMAT}
                    />

                    <FormDatePicker
                        fullSize
                        name="expirationDate"
                        label="Expiration Date"
                        sublabel="Set a date for this product to expire (expires at midnight)"
                        placeholder="Select date"
                        getValues={getValues}
                        control={control}
                        dateFormat={DATE_FORMAT}
                    />

                    <FormGroup
                        fullSize
                        type="checkbox"
                        name="hidden"
                        label="Hidden"
                        placeholder="Check this box if you don't want your students to be able to see this product. Students who have previously purchased this product `a la carte` will also not be able to see this product."
                        // prepending={["sutrapro.com"]}
                        register={register}
                    />

                </div>
            </Collapse>

            <Modal.Footer>
                <Button type="submit" variant="primary" disabled={isSaving}>
                    <span>Save changes</span>
                    {isSaving && (
                        <Spinner
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden={true}
                            className="ml-2"
                        >
                        <span className="sr-only">Sending...</span>
                      </Spinner>

                    )}
                </Button>
            </Modal.Footer>
            {/* <div className="row">
                
            </div> */}

        </form>
        <DevTool control={control} />
        </>

    )
}

function ProductEditorModal(props) {

    const {show, onHide, toEdit} = props
    var {productType} = props

    // if (toEdit?.type) {
    //     // console.log(`type: ${toEdit.type}`)
    //     switch (toEdit.type) {
    //     case "pack":
    //         pack = true
    //         subscription = false
    //         break
    //     case "subscription":
    //         pack = false
    //         subscription = true
    //         break
    //     default:
    //         break
    //     }
    // }
    var viewModel = {
        title: "",
        description: ""
    }

    // if (pack) {
    //     viewModel.title = toEdit ? "Edit package" : "Add package"
    //     viewModel.description = "A package is a group of classes that is typically discounted when a customer purchases multiple quantities. Packages do not expire and can be used on any live class."
    // } else if (subscription) {
    //     viewModel.title = toEdit ? "Edit subscription" : "Add subscription"
    //     viewModel.description = "A subscription is re-occuring payment that your clients pay you to access an unlimited amount of your services."
    // }
    if (productType === "product") {
        viewModel.title = toEdit ? "Edit Digital Product" : "Add Digital Product"
        viewModel.description = "Upload any piece of digital content. For example, a PDF, an audio file, etc."
    } else if (productType === "ondemand") {
        viewModel.title = toEdit ? "Edit Video" : "Add Video"
        viewModel.description = "Upload any piece of video content. For example, a Zoom recording, an IG TV download, etc."
    }
    
    

    return(
        <Modal
            centered
            // className={"modal-container custom-map-modal"}
            size="lg"
            // {...props}
            show={show}
            onHide={onHide}
            keyboard={false}
            backdrop={'static'}
            >
                <Modal.Header closeButton>
                    {viewModel.title}
                </Modal.Header>
                <Modal.Body>
                    {/* <p>A package is a group of classes that is typically discounted when a customer purchases multiple quantities. Packages do not expire and can be used on any live class.</p> */}
                    <p className="mb-5"><big>{viewModel.description}</big></p>
                    <ProductEditor
                    {...props}
                    toEdit={toEdit}
                    // productType={props.productType}
                    />
                </Modal.Body>
                
                
        </Modal>
    )
}

function NewProductButton(props) {

    const [open, setOpen] = React.useState(false)
    return (
        <div>
            <ProductEditorModal
            {...props}
            show={open}
            onHide={() => setOpen(false)}
            />
            <Button onClick={() => setOpen(true)}>Add New</Button>
        </div>
    );
}

export default NewProductButton

function EditProductButton(props) {

    const [open, setOpen] = React.useState(false)
    return (
        <div>

            <ProductEditorModal 
            {...props} // includes toEdit
            show={open}
            onHide={() => setOpen(false)}
            />
            <IconButton onClick={() => {
                if (!props.toEdit) {
                    window.alert("Unable to edit product")
                }
                setOpen(true)
            }}>
                <EditIcon/>    
            </IconButton>
        </div>
    );
}

export { EditProductButton }

function DeleteProductButton(props) {

    const [alert, setAlert] = React.useState(false)
    const { toDelete } = props

    const dispatch = useDispatch()

    function handleDelete() {

        console.log("Deleting offer")
        dispatch(deleteProduct(toDelete))
            .then(res => {
                setAlert(false)
            })
    }

    function confirmDelete() {

        setAlert(
            <SweetAlert
            showCancel
            confirmBtnText="Remove"
            confirmBtnBsStyle="danger"
            title="Are you sure you would like to remove?"
            onConfirm={() => handleDelete()}
            onCancel={() => setAlert(null)}
            focusCancelBtn
            >
             If you do, you can no longer sell this product.
            </SweetAlert>
        )
    }
 
    return (
        <div>
            {alert}
            <IconButton style={{color: "#ff4136"}} onClick={() => confirmDelete()}>
                <DeleteOutlineIcon/>    
            </IconButton>
        </div>
    );
}

export {DeleteProductButton}